(ns app.front.view.group.admin.archiving-config
  (:require [app.domain.archiving.model :as archiving-model]
            [app.domain.workspace.model :as workspace-model]
            [app.front.form.render :as fr]
            [app.front.ui.action-buttons :as ui-action-buttons]
            [app.front.ui.rich-text :as ui-rt]
            [app.front.ui.select :as ui-select]
            [app.front.util :as futil]
            [app.front.view.archiving.components :as arch-comp]
            [app.front.view.group.admin.core :as core]
            [app.front.view.group.admin.subs :as gas]
            [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.icons :as i]
            [core.util.util :as util]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]
            [reagent.core :as r]))


(rf/reg-event-db ::set-open-archiving-section
  (fn [db [_ cat-id schema-id]]
    (assoc-in db [::open-archiving-section cat-id] schema-id)))


(rf/reg-sub ::open-archiving-section
  (fn [db [_ cat-id]]
    (get-in db [::open-archiving-section cat-id])))


(defn- add-keys-with-same-val [m ks val]
  (reduce (fn [m k]
            (assoc m k val))
          m
          ks))


(defn update-archiving-field-config! [ptc-id config-id identifier-map attrs saved-value new-value]
  (let [identifier-map+new-val (add-keys-with-same-val identifier-map attrs new-value)
        identifier-map+old-val (add-keys-with-same-val identifier-map attrs saved-value)]
    (>evt [::gas/update-ptc-group-config-changes
           ptc-id
           config-id
           (fn [{previous-updates-for-fields :group.config/archiving-field-configs :as config}]
             (let [field-being-updated? (partial archiving-model/fields-have-same-schema? identifier-map)
                   field-with-new-vals  (-> previous-updates-for-fields
                                            (p/find-first field-being-updated?)
                                            (merge identifier-map+new-val))
                   updated-field        (cond
                                          ;Case where there are no changes
                                          (= identifier-map+new-val identifier-map+old-val) nil
                                          ;;Case where there have been some other changes for the field
                                          (= saved-value new-value) [(apply dissoc field-with-new-vals attrs)]
                                          :else [field-with-new-vals])]
               (-> config
                   (dissoc :group.config/archiving-field-configs)
                   (p/assoc-if :group.config/archiving-field-configs
                               (->> previous-updates-for-fields
                                    (remove field-being-updated?)
                                    (concat updated-field)
                                    seq)))))])))


(defn- get-archiving-field-config-values [saved-entity updates-for-the-entity]
  (let [saved-value          (:archiving-field/value saved-entity)
        saved-selected-value (:archiving-field/selected-value saved-entity)
        saved-disabled-value (:archiving-field/disabled? saved-entity)]
    {:saved-value saved-value
     :value       (get updates-for-the-entity :archiving-field/value saved-value)

     :saved-selected-value saved-selected-value
     :selected-value       (get updates-for-the-entity :archiving-field/selected-value saved-selected-value)

     :saved-disabled-value saved-disabled-value
     :disabled-value       (get updates-for-the-entity :archiving-field/disabled? saved-disabled-value)}))


(defn hide-archiving-field? [saved-arc-field-configs updates-for-arc-field-configs {:keys [action schema-id value]}]
  (when (#{:hide :show} action)
    (let [condition-is-true? (-> (or (-> updates-for-arc-field-configs
                                         (archiving-model/find-field-by-schema-id schema-id)
                                         archiving-model/field-has-some-value)
                                     (archiving-model/find-field-by-schema-id saved-arc-field-configs schema-id))
                                 :archiving-field/value
                                 (= value))]
      (if condition-is-true?
        (= action :hide)
        (= action :show)))))


(defn editor-for-archiving-field-config
  [{:keys [tr
           ptc-id
           permit-type
           category-config
           selected-settings]}
   {:archiving-field-schema/keys [id
                                  condition
                                  field-name] schema-db-id :db/id :as archiving-field-schema}]

  (let [cat-config-id                (:db/id category-config)
        open?                        (= (<sub [::open-archiving-section cat-config-id]) id)
        saved-entity                 (-> (:group.config/archiving-field-configs category-config)
                                         (archiving-model/find-field-by-schema-id id))
        schema-db-id+schema-id       (select-keys archiving-field-schema
                                                  [:db/id :archiving-field-schema/id])
        identifier-map               (if saved-entity
                                       {:db/id                  (:db/id saved-entity)
                                        :archiving-field/schema schema-db-id+schema-id}
                                       {:archiving-field/schema schema-db-id+schema-id
                                        :entity/type            :entity.type/archiving-field-config})
        updates-for-fields           (-> selected-settings
                                         (get-in [cat-config-id
                                                  :group.config/archiving-field-configs]))
        updates-for-current-field    (archiving-model/find-field-by-schema-id updates-for-fields id)
        hide-current-field?          (hide-archiving-field? (:group.config/archiving-field-configs category-config)
                                                            updates-for-fields
                                                            condition)
        {:keys [saved-value
                value
                saved-selected-value
                selected-value]}     (get-archiving-field-config-values saved-entity
                                                                        updates-for-current-field)
        update-fn!                   (partial update-archiving-field-config!
                                              ptc-id
                                              cat-config-id
                                              identifier-map)]
    (when-not hide-current-field?
      [:div.p-3.cursor-pointer.border.border-grey.border-solid
       {:class    "bg-white"
        :on-click #(>evt [::set-open-archiving-section cat-config-id (when-not open? id)])}
       [:div.flex.justify-between.items-center
        [:div {:on-click #(.stopPropagation %)}
         [:div (tr [field-name])]]
        (cc/icon
          {:icon        (if open? i/chevron-up i/chevron-down)
           :class-name  ""
           :description (tr [:review.config/selected-review-config])})]
       (when open?
         [:div.p-3 {:on-click #(.stopPropagation %)}
          [:div.flex.flex-wrap
           (arch-comp/archiving-field-input
             archiving-field-schema
             {:value                value
              :id                   (str permit-type "-" cat-config-id "-" schema-db-id)
              :selected-value       selected-value
              :tr                   tr
              :label                :archiving/default-value
              :config-view?         true
              :on-change            (partial update-fn!
                                             [:archiving-field/value]
                                             saved-value)
              :on-change-for-select (partial update-fn!
                                             [:archiving-field/value :archiving-field/selected-value]
                                             saved-selected-value)})]])])))

(defn toggle [{:keys [setting tr config]}]
  [cc/toggle {:toggled    (boolean (get config setting))
              :id         (str (:db/id config) "-" (name setting))
              :label-text (tr [setting])
              :class-name "mb-4"
              :on-toggle  #(core/do-save-group-config config
                                                      {setting %})}])

(defn hidden-help [{{:keys [:group.config/archiving-hidden-help
                            :db/id]
                     :as   config}                              :config
                    :keys                                       [tr]}]
  (r/with-let [archiving-hidden-help (or archiving-hidden-help "")
               *value                (r/atom nil)
               *cancel-count         (r/atom 0)]
    (let [value      @*value
          unchanged? (= value archiving-hidden-help)]
      [:div.my-2
       [:label.bx--label (tr [:group.config/archiving-hidden-help])]
       ;; force redraw with initial value after cancel
       ^{:key (str id "-hidden-help-v" @*cancel-count)}
       [ui-rt/editor-legacy {:id            (str id "-hide-help")
                             :initial-value archiving-hidden-help
                             :on-change     #(reset! *value %)}]
       (when value
         [:div.mt-2.flex.justify-end
          [ui-action-buttons/save-cancel-buttons
           (util/mmap {:on-cancel      (fn [_]
                                         (swap! *cancel-count inc)
                                         (reset! *value archiving-hidden-help))
                       :on-save        (fn [_]
                                         (reset! *value nil)
                                         (core/do-save-group-config config
                                                                    {:group.config/archiving-hidden-help value}))
                       :save-disabled? (or (nil? value)
                                           unchanged?)
                       :size           :small}
                      tr)]])])))


(defn automatic-archiving-days [{:keys [config tr]}]
  (let [field-key      :group.config/automatic-archiving-after-days
        original-value (get config field-key)]
    (r/with-let [*val (r/atom original-value)]
      [:div.mb-4
       (let [on-blur (fn [_]
                       (let [numeric-value (futil/parse-int @*val)]
                         (when (and (not (str/blank? @*val))
                                    (not= numeric-value original-value))
                           (core/do-save-group-config
                             config
                             {field-key numeric-value}))))]
         [fr/number-input {:on-change  (fn [val] (reset! *val (futil/tval val)))
                           :invalid    (str/blank? @*val)
                           :required   true
                           :on-blur    on-blur
                           :label-text (tr [field-key])
                           :value      @*val}])])))


(defn archiving-enabled-config [tr root-configs]
  (let [can-enable-hide? (<sub [::gas/has-feature? :group.feature/can-enable-hide-workspace-after-archiving?])]
    [:<>
     (for [{:keys [:db/id
                   :group.config/target
                   :group.config/archiving-hides-workspace?]
            :as   config}                                    root-configs]
       ^{:key (str id "-archiving")}
       [:div
        [:h3.mb-4 (tr [target])]
        [toggle (util/mmap {:setting :group.config/archiving-enabled?} tr config)]

        (when (:group.config/archiving-enabled? config)
          [:<>
           [toggle (util/mmap {:setting :group.config/automatic-archiving-enabled?} tr config)]
           (when (:group.config/automatic-archiving-enabled? config)
             [automatic-archiving-days (util/mmap tr config)])])
        (when can-enable-hide?
          [toggle (util/mmap {:setting :group.config/archiving-hides-workspace?} tr config)])
        (when (and can-enable-hide? archiving-hides-workspace?)
          [hidden-help (util/mmap tr config)])])]))


(defn workspace-sensitivity-selector
  [{:keys [ptc-id permit-type category-config tr selected-settings]}]
  (let [saved-value   (:group.config/workspace-sensitivity-level category-config)
        current-value (or (get-in selected-settings [(:db/id category-config) :group.config/workspace-sensitivity-level])
                          saved-value
                          workspace-model/default-value-for-workspace-sensitivity)
        on-change-fn  (fn [attr new-value]
                        (>evt [::gas/update-ptc-group-config-changes
                               ptc-id
                               (:db/id category-config)
                               #(if (= new-value
                                       (or saved-value
                                           workspace-model/default-value-for-workspace-sensitivity))
                                  (dissoc % attr)
                                  (assoc % attr new-value))]))]
    [:div.mb-4 {:on-click #(.stopPropagation %)}
     [ui-select/select
      {:id           (str "workspace-sensitivity-" permit-type (:db/id category-config))
       :label-text   (tr [:group.config/default-sensitivity-level])
       :values       workspace-model/workspace-sensitivity-values
       :val->str     (comp tr vector)
       :allow-empty? false
       :on-change    (partial on-change-fn :group.config/workspace-sensitivity-level)
       :value        current-value}]]))
